import React from 'react'
import { Trans } from '@mc/i18n'
import {
  i18nInstance,
  CORE_MEMBERSHIP_LANGUAGE_CLEANUP_I18N_NAMESPACE,
} from '../i18n'

const t = i18nInstance.getFixedT(
  null,
  CORE_MEMBERSHIP_LANGUAGE_CLEANUP_I18N_NAMESPACE,
)

const AnswerComponent = () => (
  <p className='mc-opacity--hinted'>
    <Trans
      i18nKey='faq.general.answer3'
      ns={CORE_MEMBERSHIP_LANGUAGE_CLEANUP_I18N_NAMESPACE}
    />
  </p>
)

export const certificatesFAQ = () => ({
  uuid: 'faq.general.certificates',
  label: t('faq.general.question3'),
  title: t('faq.general.question3'),
  AnswerComponent,
  answer: <AnswerComponent />,
})
